<template>
<el-dialog class="codeModel" title="" :visible.sync="centerDialogVisible" :before-close="handleClose" center v-if="enterprisesInformation">
    <!-- 微信模态框 -->
    <div class="wechatCode" v-show="modalStatus=='wechat'">
        <img :src="enterprisesInformation.ContactUsCode">
        <span>扫一扫添加微信</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="postCenterDialogVisibleFalse" v-show="modalStatus!='wechat'">取 消</el-button>
            <el-button type="primary" @click="postCenterDialogVisibleFalse" round>确 定</el-button>
        </span>
    </div>
    <!-- 微信模态框 -->
    <!-- 抖音模态框 -->
    <div class="wechatCode" v-show="modalStatus=='douyin'">
        <img :src="enterprisesInformation.SchoolDouYinCode">
        <span>扫一扫关注抖音</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="postCenterDialogVisibleFalse" v-show="modalStatus!='douyin'">取 消</el-button>
            <el-button type="primary" @click="postCenterDialogVisibleFalse" round>确 定</el-button>
        </span>
    </div>
    <!-- 抖音模态框 -->
</el-dialog>
</template>

<script>
export default {
    //该页面的控制数据
    data() {
        return {

        }
    },
    computed: {
        centerDialogVisible() {
            return this.$store.getters.getCenterDialogVisible;
        },
        //弹窗状态
        modalStatus() {
            return this.$store.getters.getModalStatus;
        },
        //学校信息
        enterprisesInformation() {
            if (this.$store.getters.get_enterprisesInformation) {
                return this.$store.getters.get_enterprisesInformation;
            } else {
                return JSON.parse(localStorage.getItem("school"));
            }
        },
    },
    //父控件传过来的参数
    props: {

    },
    //监听函数
    wacth: {

    },
    //进入页面执行的函数
    mounted() {

    },
    //定义函数
    methods: {
        //存储到Vuex中模态框的状态为false
        postCenterDialogVisibleFalse() {
            this.$store.commit('updateCenterDialogVisible', false);
        },
        //点击关闭按钮
        handleClose(done) {
            this.$store.commit('updateCenterDialogVisible', false)
        },
    },
    //增加控件
    components: {

    }
}
</script>

<style lang="css" scoped>
.codeModel>>>.el-dialog {
    max-width: 460px;
    min-width: 300px;
}

.wechatCode {
    display: flex;
    flex-flow: column;
    align-items: center;
}

.wechatCode img {
    max-width: 240px;
    max-height: 240px;
    width: 100%;
    /* height: 200px; */
}

.wechatCode span {
    margin-top: 20px;
}
</style>
